import { Vue, Component } from 'vue-property-decorator';
import { capitalize } from '@/utils';

@Component({
  name: 'DateMixins',
})
export default class DateMixins extends Vue {
  public formatedYear(value: string): string {
    const [year, month] = value.split('-');
    const date = new Date();
    if (month) {
      date.setMonth(parseInt(month, 10) - 1);
    }
    const name = date.toLocaleString(this.language, { month: 'long' });
    return `${capitalize(name)} ${year}`;
  }
}
